import { useCallback } from "react";

import useLocalizedNavigation from "@/hooks/useLocalizedNavigation";
import { useLocalizedPathname } from "@/hooks/useLocalizedPathname";

import getMediaFilePreviewPaths, { type MediaFilePreviewPathOptions } from "./getMediaFilePreviewPaths";

export default function useMediaFilePreviewNavigation(options: MediaFilePreviewPathOptions) {
  const navigate = useLocalizedNavigation();
  const localizePath = useLocalizedPathname();
  const { pagePath, relatedEntityPath } = getMediaFilePreviewPaths(options);

  const handleOpenRelatedEntity = useCallback(() => {
    if (relatedEntityPath) {
      navigate(relatedEntityPath);
    }
  }, [navigate, relatedEntityPath]);

  return {
    pageHref: localizePath(pagePath),
    relatedEntityHref: relatedEntityPath ? localizePath(relatedEntityPath) : undefined,
    handleOpenRelatedEntity,
  };
}
